import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleChargingInsightsService {

  constructor(private readonly httpClient: HttpClient) { }

  getCurrentChargingInsights(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'current-charging-insights?batteryIdentifiers=' + deviceSerialNumber);
  }
}
